module.exports = __webpack_public_path__ + "static/media/36.74295640.mp3";